<template>
  <div>
    <section class="section">
      <div class="container">
        <TituloPrincipal :titulo="titulo" :subtitulo="subtitulo"/>
        <form @submit.prevent>
          <div class="columns is-multiline">

            <div class="column is-4">
              <b-field
                label="Contraseña Actual"
                :type="{'is-danger': errors.has('contraseña actual')}"
                :message="errors.first('contraseña actual')"
              >
                <b-input
                  type="password"
                  v-model="contrasena"
                  name="contraseña actual"
                  v-validate="'required'"
                  v-on:keyup.enter="cambiarContraseña()"
                />
              </b-field>
            </div>
            <div class="column is-4">
              <b-field
                label="Nueva Contraseña"
                :type="{'is-danger': errors.has('nueva contraseña')}"
                :message="errors.first('nueva contraseña')"
              >
                <b-input
                  type="password"
                  v-model="nuevaContrasena"
                  name="nueva contraseña"
                  v-validate="'required|min:8'"
                  v-on:keyup.enter="cambiarContraseña()"
                />
              </b-field>
            </div>
            <div class="column is-4">
              <b-field
                label="Confirmar Nueva Contraseña"
                :type="{'is-danger': errors.has('confirmar nueva contraseña')}"
                :message="errors.first('confirmar nueva contraseña')"
              >
                <b-input
                  type="password"
                  v-model="confirmarNuevaContrasena"
                  name="confirmar nueva contraseña"
                  v-validate="{ required: true, is: nuevaContrasena }"
                  v-on:keyup.enter="cambiarContraseña()"
                />
              </b-field>
            </div>

            <div class="column is-4">
              <button
                class="button is-secundary"
                v-bind:class="{'is-loading': isLoading}"
                @click="cambiarContraseña()"
                v-on:keyup.enter="cambiarContraseña()"
              >Cambiar Contraseña</button>
              <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
            </div>

          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import TituloPrincipal from '@/components/TituloPrincipal.vue'

export default {
  name: 'ChangePassword',
  data () {
    return {
      titulo: 'Cambiar contraseña',
      subtitulo: 'Ingrese los datos de su nueva contraseña',
      isLoading: false,
      contrasena: '',
      nuevaContrasena: '',
      confirmarNuevaContrasena: ''
    }
  },
  components: {
    TituloPrincipal
  },
  mounted () {
    const dict = {
      custom: {
        'confirmar nueva contraseña': {
          is: 'Las contraseñas no coinciden'
        }
      }
    }

    this.$validator.localize('es', dict)
  },
  methods: {
    cambiarContraseña () {
      var componenteVue = this
      this.isLoading = true

      function cambiarContrasenaCallback (error, data) {
        componenteVue.isLoading = false
        if (error) {
          componenteVue.$buefy.dialog.alert({
            title: 'Error - ' + error.response.data.status,
            message: error.response.data.message,
            type: 'is-danger',
            hasIcon: true,
            icon: 'close-circle-outline',
            iconPack: 'mdi'
          })
        } else {
          componenteVue.$buefy.dialog.alert({
            title: 'Contraseña Modificada',
            message: data.message,
            type: 'is-success',
            hasIcon: true,
            icon: 'account-check',
            iconPack: 'mdi',
            onConfirm: () => componenteVue.$router.push({ name: 'inicio' })
          })
        }
      }

      // Valida el form (y valida el recaptcha)
      this.$validator.validateAll().then(result => {
        // Si esta todo bien realiza el llamado a cambiar contraseña en la api y ejecuta callback
        if (result) {
          // Crea el json
          const jsonData = {
            contrasena: this.contrasena,
            nuevaContrasena: this.nuevaContrasena,
            confirmarNuevaContrasena: this.confirmarNuevaContrasena
          }

          // Ejecuta llamdo sobre api
          componenteVue.$apiService.cambiarContrasena(jsonData, cambiarContrasenaCallback)
        } else { // Sino renderiza toast con error
          this.isLoading = false
          componenteVue.$buefy.toast.open({
            message: 'Revise los datos',
            type: 'is-danger',
            position: 'is-top'
          })
        }
      })
    }
  }
}
</script>
